export default __webpack_public_path__ + "static/media/tech blog.8a6a9a06.png";